import React from "react";
import styled from "styled-components";
import { Card, Button, Space, Table } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const TableCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .ant-card-body {
    padding: 16px;
    overflow-x: auto;
  }

  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table {
    font-size: 12px;
  }

  .ant-table-thead > tr > th {
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 600;
  }

  .ant-table-tbody > tr > td {
    padding: 8px 12px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    .ant-card-body {
      padding: 12px;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 6px 8px;
      font-size: 11px;
    }
  }
`;

const RefreshButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
`;

const RefreshableTableCard = ({
  title,
  columns,
  dataSource,
  rowKey,
  loading,
  onRefresh,
  onViewAll,
  viewAllPath,
  scroll,
  style,
}) => {
  const resolvedRowKey =
    rowKey ??
    ((record, index) => {
      const id = record?.id ?? record?._id ?? record?.key;
      return id != null ? String(id) : `row-${index}`;
    });

  return (
    <TableCard
      title={title}
      extra={
        <Space size="small" align="center">
          <RefreshButton
            key="refresh"
            type="text"
            size="small"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
            title={`Refresh ${title}`}
          />
          <Button key="view-all" type="link" onClick={onViewAll}>
            View All
          </Button>
        </Space>
      }
    >
      <Table
        columns={columns}
        dataSource={dataSource}
        rowKey={resolvedRowKey}
        pagination={false}
        size="small"
        loading={loading}
        scroll={scroll}
        style={style}
      />
    </TableCard>
  );
};

export default RefreshableTableCard;
